import { BASE_URL } from "../api/axios";

const MAX_SIDE = 1600;

export const socialImageUrl = (name) => `${BASE_URL}/social-images/${name}`;

// Shrinks large photos before upload: faster on mobile and well under the
// proxy's body size limit. The server resizes and re-encodes anyway.
async function shrinkImage(file) {
  if (
    file.type === "image/gif" ||
    file.size < 500 * 1024 ||
    typeof createImageBitmap !== "function"
  ) {
    return file;
  }
  try {
    const bitmap = await createImageBitmap(file, {
      imageOrientation: "from-image",
    });
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close?.();
    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", 0.85)
    );
    return blob && blob.size < file.size ? blob : file;
  } catch (err) {
    return file;
  }
}

// Uploads one photo and returns the stored file name for the post/comment.
export async function uploadSocialImage(axiosPrivate, file) {
  const upload = await shrinkImage(file);
  const formData = new FormData();
  formData.append("image", upload, upload === file ? file.name : "photo.jpg");
  // Without this header axiosPrivate's JSON default turns FormData into JSON.
  const { data } = await axiosPrivate.post("/posts/images", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.image;
}
